import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
// import { base_URL } from "../../../../utils/api";
import axiosInstance from "../../../../axiosinterceptor";
// const initialPageSize = JSON.parse(sessionStorage.getItem("enableHCPQueryParamsFunctionality") || "false")
//   ? 100
//   : 20;


const initialState = {
  selectedEpisode: {},
  selectedQueueworkSpace:null,
  viewEpisodesFiltersList: {
    episodesFilterList: [],
    episodesFilterListLoading: false,
    episodesFilterListError: null,
  },
  episodeListFilterObj: {
    page: 1,
    page_size: 20,
    sort_by: [],
    sort_order: [],
    module_name: "",
    status: [],
    speciality: [],
    health_fund_contract: [],
    episode_identifier: [],
    medical_record_number: [],
    admission_from_date: null,
    admission_to_date: null,
    separation_from_date: null,
    separation_to_date: null,
    length_of_stay: [],
    los_op: "",
    document_name: [],
    drg: [],
  },
   documentTypesFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
};

export const getFilterEpisodeLists = createAsyncThunk(
  "/getFilterEpisodeLists",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    const episodesPayload = {
      body: payload,
    };
    const header = {
      content_type: "application.json",
    };
    try {
      const response = await axiosInstance.post("/Filter_navigation_acs",
        payload,
      );
      // const data = JSON.parse(response.data.body);
      const data = response.data;
      // console.log(data, 'data1')
      return fulfillWithValue(data);
      // return data;
    } catch (error) {
      console.error("Error fetching episodes:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
      // throw error;
    }
  },
);

export const getDocumentTypesFilterOptions = createAsyncThunk(
  "/getDocumentTypesFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/document_type_filter", payload);
      const data = response?.data;
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Error fetching filter episodes options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

const episodeListSlicer = createSlice({
  name: "episodeList",
  initialState,
  reducers: {
    selectedEpisodeList: (state, action) => {
      state.selectedEpisode = action.payload;
    },
   setEpisodeListFilterObj: (state, action) => {
      state.episodeListFilterObj = {
        ...state.episodeListFilterObj,
        ...action.payload,
      };
    },
    setSelectedQueue: (state, action) => {
      state.selectedQueueworkSpace = action.payload;
    },
    setDocumentTypesFilterSearch(state, action) {
      state.documentTypesFilterOptions.search = action.payload;
    },
    resetEpisodeListFilters: (state) => {
      state.episodeListFilterObj = {
        page: 1,
        page_size: 20,
        sort_by: [],
        sort_order: [],
        module_name: "",
        status: [],
        speciality: [],
        health_fund_contract: [],
        episode_identifier: [],
        medical_record_number: [],
        admission_from_date: null,
        admission_to_date: null,
        separation_from_date: null,
        separation_to_date: null,
        length_of_stay: [],
        los_op: "",
        document_name: [],
        drg: [],
      };
    },
    resetFilterByDocumentTypes(state, action) {
      const key = action.payload;
      state[key].search = "";
      state[key].data = [];
      state[key].pageNumber = 1;
      state[key].hasMore = true;
      state[key].loading = false;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getFilterEpisodeLists.pending, (state) => {
        state.viewEpisodesFiltersList.episodesFilterListLoading = true;
        state.viewEpisodesFiltersList.episodesFilterListError = null;
      })
      .addCase(getFilterEpisodeLists.fulfilled, (state, action) => {
        state.viewEpisodesFiltersList.episodesFilterListLoading = false;
        state.viewEpisodesFiltersList.episodesFilterList = action.payload;
      })
      .addCase(getFilterEpisodeLists.rejected, (state, action) => {
        state.viewEpisodesFiltersList.episodesFilterListLoading = false;
        state.viewEpisodesFiltersList.episodesFilterListError = action.payload;
      })
      .addCase(getDocumentTypesFilterOptions.pending, (state) => {
        state.documentTypesFilterOptions.loading = true;
        state.documentTypesFilterOptions.error = null;
      })
      .addCase(getDocumentTypesFilterOptions.fulfilled, (state, action) => {
        // const documentTypes = action.payload?.document_names || [];

        // state.documentTypesFilterOptions.loading = false;
        // state.documentTypesFilterOptions.data = documentTypes
        
        state.documentTypesFilterOptions.loading = false;
        if (action.payload?.page_number === 1) {
          state.documentTypesFilterOptions.data =
            action.payload?.document_names || [];
        } else {
          state.documentTypesFilterOptions.data = [
            ...state.documentTypesFilterOptions.data,
            ...(action.payload?.document_names || []),
          ];
        }
        const isValidPage = action.payload?.has_more ?? false;
        state.documentTypesFilterOptions.hasMore = isValidPage;
        state.documentTypesFilterOptions.pageNumber = action.payload?.page_number;
      // })
        
      })
      .addCase(getDocumentTypesFilterOptions.rejected, (state, action) => {
        state.documentTypesFilterOptions.loading = false;
        state.documentTypesFilterOptions.error = action.payload;
      }),
      
});

export const {
  selectedEpisodeList,
  setEpisodeListFilterObj,
  setSelectedQueue,
  setDocumentTypesFilterSearch,
  resetEpisodeListFilters,
  resetFilterByDocumentTypes
} = episodeListSlicer.actions;

export default episodeListSlicer.reducer;
